export default __webpack_public_path__ + "static/mine-free_small-image_1-ff41d9cbb64c38c7eb63cd3a19f0fe37.png";